import React, { DetailedHTMLProps, ButtonHTMLAttributes } from "react"
import { Link } from "react-router-dom";
export interface ButtonProps extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  className?: string;
}

export const Button: React.FC<ButtonProps> = (props) => {
  return <button
    {...props}
    className={`btn ${props.className}`}>
    <div className="btn__label">
      {props.children}
    </div>
  </button>
}

export interface LinkButtonProps {
  className?: string;
  href: string;
}

function redirectTo(e: React.SyntheticEvent<any>) {
  // if (IS_MOBILE) {
  let el: HTMLAnchorElement = e.currentTarget as HTMLAnchorElement;

  window.location.href = el.href;
  // }
}

export const LinkButton: React.SFC<LinkButtonProps> = (props) => {
  let cls = props.className || "";
  // {props.label}
  return (
    <Link to={props.href || ""} className={"btn " + cls} onTouchStart={redirectTo}>
      <div className="btn__label">
        {props.children}
      </div>
    </Link>
  )
}
